module.exports = __webpack_public_path__ + "img/icon-copytext.51b0d5b0.png";